const modules = import.meta.glob('./photos/**/*.jpg', { eager: true, import: 'default' }) as Record<string, string>;
const thumbModules = import.meta.glob('./thumbs/**/*.webp', { eager: true, import: 'default' }) as Record<string, string>;

/** Full-size (1600px) photo URL. Returns '' when the slug doesn't exist. */
export const photo = (slug: string): string => modules[`./photos/${slug}`] ?? '';

/** 800px WebP thumbnail (falls back to the full photo). Generated by scripts/make-thumbs.mjs. */
export const thumb = (slug: string): string =>
  thumbModules[`./thumbs/${slug.replace(/\.jpg$/, '.webp')}`] ?? photo(slug);

/** srcset pairing the thumbnail with the full photo so small tiles/phones pick the light one. */
export const photoSrcSet = (slug: string): string | undefined => {
  const t = thumbModules[`./thumbs/${slug.replace(/\.jpg$/, '.webp')}`];
  const p = photo(slug);
  return t && p ? `${t} 800w, ${p} 1600w` : undefined;
};
